/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_Giveawaydate1Inputs */

const id_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Giveaway`)
};

const ms_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Pemberian`)
};

const da_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway Dato`)
};

const de_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway-Datum`)
};

const en_us2_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway Date`)
};

const es_es2_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de regalo`)
};

const es_mx2_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de regalo`)
};

const fil_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng Giveaway`)
};

const fr_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de gratuité`)
};

const it_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data giveaway`)
};

const hu_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajándék dátuma`)
};

const nl_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveawaydatum`)
};

const no_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway-dato`)
};

const pl_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data rozdania`)
};

const pt_br2_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data do sorteio`)
};

const pt_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data da oferta grátis`)
};

const ro_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data ofertei gratuite`)
};

const fi_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaisjaon päivä`)
};

const sv_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utlottningsdatum`)
};

const vi_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày tặng miễn phí`)
};

const tr_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedava Oyun Tarihi`)
};

const cs_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum výprodeje`)
};

const bg_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на безплатна игра`)
};

const ru_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата раздачи`)
};

const uk_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата роздачі`)
};

const ar_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الهدية`)
};

const hi_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गिवअवे तारीख़`)
};

const th_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่แจกฟรี`)
};

const ja_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配布日`)
};

const zh_cn2_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赠送日期`)
};

const zh_hant1_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`贈送日期`)
};

const ko_search_sort_giveawaydate1 = /** @type {(inputs: Search_Sort_Giveawaydate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 배포일`)
};

/**
* | output |
* | --- |
* | "Giveaway Date" |
*
* @param {Search_Sort_Giveawaydate1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_sort_giveawaydate1 = /** @type {((inputs?: Search_Sort_Giveawaydate1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_Giveawaydate1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_sort_giveawaydate1(inputs)
	if (locale === "ms") return ms_search_sort_giveawaydate1(inputs)
	if (locale === "da") return da_search_sort_giveawaydate1(inputs)
	if (locale === "de") return de_search_sort_giveawaydate1(inputs)
	if (locale === "en-US") return en_us2_search_sort_giveawaydate1(inputs)
	if (locale === "es-ES") return es_es2_search_sort_giveawaydate1(inputs)
	if (locale === "es-MX") return es_mx2_search_sort_giveawaydate1(inputs)
	if (locale === "fil") return fil_search_sort_giveawaydate1(inputs)
	if (locale === "fr") return fr_search_sort_giveawaydate1(inputs)
	if (locale === "it") return it_search_sort_giveawaydate1(inputs)
	if (locale === "hu") return hu_search_sort_giveawaydate1(inputs)
	if (locale === "nl") return nl_search_sort_giveawaydate1(inputs)
	if (locale === "no") return no_search_sort_giveawaydate1(inputs)
	if (locale === "pl") return pl_search_sort_giveawaydate1(inputs)
	if (locale === "pt-BR") return pt_br2_search_sort_giveawaydate1(inputs)
	if (locale === "pt") return pt_search_sort_giveawaydate1(inputs)
	if (locale === "ro") return ro_search_sort_giveawaydate1(inputs)
	if (locale === "fi") return fi_search_sort_giveawaydate1(inputs)
	if (locale === "sv") return sv_search_sort_giveawaydate1(inputs)
	if (locale === "vi") return vi_search_sort_giveawaydate1(inputs)
	if (locale === "tr") return tr_search_sort_giveawaydate1(inputs)
	if (locale === "cs") return cs_search_sort_giveawaydate1(inputs)
	if (locale === "bg") return bg_search_sort_giveawaydate1(inputs)
	if (locale === "ru") return ru_search_sort_giveawaydate1(inputs)
	if (locale === "uk") return uk_search_sort_giveawaydate1(inputs)
	if (locale === "ar") return ar_search_sort_giveawaydate1(inputs)
	if (locale === "hi") return hi_search_sort_giveawaydate1(inputs)
	if (locale === "th") return th_search_sort_giveawaydate1(inputs)
	if (locale === "ja") return ja_search_sort_giveawaydate1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_sort_giveawaydate1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_sort_giveawaydate1(inputs)
	return ko_search_sort_giveawaydate1(inputs)
});
export { search_sort_giveawaydate1 as "search.sort.giveawayDate" }